'use client';

import { SessionProvider as NextAuthSessionProvider } from 'next-auth/react';
import type { Session } from 'next-auth';

/**
 * 全站 SessionProvider（client）。
 *
 * session prop：由 server（root layout 的 auth()）傳入的初始 session。
 * - 有傳 → useSession() 第一幀就有正確狀態（不進 loading），
 *   SSR HTML 直接含「登入/登出」按鈕（hybrid 做法，首繪即出現）
 * - 沒傳（undefined）→ 回退舊行為：mount 後自己 fetch /api/auth/session
 *
 * 校準仍由 next-auth 負責：切換分頁/其他 tab 登入登出時背景 refetch。
 *
 * refetch 設定（修正「隔天 session 過期後 UI 仍顯示登出鈕」）：
 * - refetchInterval={5 * 60}：每 5 分鐘背景向 /api/auth/session 校準一次，
 *   避免 useSession() 記憶體快取長期 stale。
 * - refetchOnWindowFocus：預設即為 true，這裡明確標註以確保每次分頁 focus
 *   立即校準，蓋掉 bfcache 還原的舊 HTML + 舊 session 快取。
 */
export function SessionProvider({
  children,
  session,
}: {
  children: React.ReactNode;
  session?: Session | null;
}) {
  return (
    <NextAuthSessionProvider
      session={session}
      refetchInterval={5 * 60}
      refetchOnWindowFocus={true}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
